// External Dependencies:
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import keycode from 'keycode'

class NewsletterModal extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			isOpen: true
		}

		this.root = document.getElementById( 'newsletter-modal' )
		this.el = document.createElement( 'div' )
	}

	componentDidMount() {
		this.root.appendChild( this.el )
		document.documentElement.classList.add( 'with-confirm-open' )
		document.addEventListener( 'mousedown', this.handleClickOutside )
		document.addEventListener( 'keydown', this.handleKeyPress )
	}

	componentWillUnmount() {
		this.root.removeChild( this.el )
		document.documentElement.classList.remove( 'with-confirm-open' )
		document.removeEventListener( 'mousedown', this.handleClickOutside )
		document.removeEventListener( 'keydown', this.handleKeyPress )
	}

	handleClickOutside = ( e ) => {
		if ( this.outside == e.target ) {
			this.handleCancel()
		}
	}

	handleKeyPress = ( e ) => {
		if ( 'esc' == keycode( e ) ) {
			this.handleCancel()
		}
	}

	handleAccept = () => {
		this.setState({
			isOpen: false
		})

		setTimeout( () => {
			this.props.accept()
		}, 300 )
	}

	handleCancel = () => {
		this.setState({
			isOpen: false
		})

		setTimeout( () => {
			this.props.cancel()
		}, 300 )
	}

	render() {
		const { isOpen } = this.state
		const confirmClassName = isOpen ? 'newsletter-modal is-open' : 'newsletter-modal is-closed'

		const confirmMarkup = (
			<div className={ confirmClassName } ref={ ( e ) => { this.outside = e } } tabIndex="0">
				<div className="-inner">
					<div className="section-newsletter">
						<div className="-inner">
							<div className="-close" onClick={ this.handleCancel }>
								<i className="icon-times"></i>
							</div>

							<div className="-envelope">
								<div className="-envelope-bottom"></div>

								<div className="-chickens">
									<img src={ `${siteData.images_url}header/anicoop-chickens.png` } alt="" />
								</div>

								<div className="-paper">
									<h4>Let’s keep in touch.</h4>

									<form action="" method="post" target="_blank">
										<div className="form-item">
											<input type="text" name="FIRSTNAME" placeholder="Your name" />
										</div>

										<div className="form-item">
											<input type="email" name="EMAIL" placeholder="Your email" />
										</div>

										<div className="form-item">
											<button className="button" type="submit" name="subscribe">Subscribe</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)

		return ReactDOM.createPortal(
			confirmMarkup,
			this.el,
		)
	}
}

export default NewsletterModal



// WEBPACK FOOTER //
// ./components/NewsletterModal/NewsletterModal.jsx